import "./Styles.scss"
import LogoBranco from "../../../assets/images/logo-edp-white.png";
import avatar from "../../../assets/avatar.png"
import React, { ReactNode, RefObject, useContext, useEffect, useRef } from "react";

import { IMenuModel } from "../../../models/DTO/MenuModel";

import { Accordion, Button, Card, Container, Dropdown, Form, Image, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { IUserModel } from "../../../models/DTO/UserModel";

import { SignOutButton } from "../../SignOutButton/Component";
import { UIHelper } from "../../../Helpers/helper";
import { RdContextType } from "../../../@types/Rd";
import RdContext from "../../../contexts/RdProvider";
import DynamicIcon from "../../DynamicIcon/Component";
import { IconBaseProps } from "react-icons";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { SignInButton } from "../../SignInButton/Component";
import CompanySelection from "../../CompanySelection/Component";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "../../../Hooks/isUserAuthorized";
import SideMenu from "../SideMenu/Component";
import MasterSelectorActivate from "../../MasterSelectorActivate/Component";
import { useWindowSize } from "../../../Hooks/useWindowSize";

const helper: UIHelper = new UIHelper();

const RenderConfigMenus = ({ menus = [], isUserAuthorized }: { menus: IMenuModel[], isUserAuthorized: boolean }): JSX.Element => {
    const configRef = useRef<HTMLDivElement>(null),
        iconProps: IconBaseProps = { className: "icon-config" };

    const getAdmMenuHeader = (): ReactNode => {

        return (
            <Accordion.Button eventkey="AdmConfg"
                aria-haspopup="true"
                aria-expanded="false"
                as={NavDropdown.Header}
                className="icon-config"
            >
                <DynamicIcon Family="BootstrapIcons" Name="BsGear" propsIcon={iconProps} />
            </Accordion.Button>
        )
    }

    return (
        <>
            {
                isUserAuthorized &&
                <NavDropdown
                    className="edp-config"
                    id="AdmConfg"
                    title={getAdmMenuHeader()}
                    ref={configRef}
                >
                    {
                        menus
                            .sort((a, b) => a.Order - b.Order)
                            .map(menu => { return (<NavDropdown.Item key={`configMenu-${menu.Order}`} href={menu.Url}>{menu.Name}</NavDropdown.Item>) })
                    }
                </NavDropdown>
            }
        </>
    )
}

const RenderUserMenu = ({ userInfo }: { userInfo: IUserModel | undefined }): JSX.Element => {
    const avatarRef = useRef<HTMLDivElement>(null),
        avatarPath = userInfo && userInfo.PictureUrl && userInfo.PictureUrl != "" ? userInfo.PictureUrl : avatar,
        scrollToUserInfo: () => void = () => avatarRef?.current != null && avatarRef.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" }),
        { UI, currentCompany } = useContext(RdContext) as RdContextType,
        screenInfo = useWindowSize();

    const UserHeader = (): ReactNode => {
        return (
            <Accordion.Button eventkey="navbar-avatar"
                aria-haspopup="true"
                aria-expanded="false"
                as={NavDropdown.Header}
                onClick={() => { screenInfo.Width <= 1280 && setTimeout(() => scrollToUserInfo(), 100) }}
            >
                <Image
                    src={avatarPath}
                    alt="avatar"
                    accessKey="avatarPhoto"
                    loading="lazy"
                    title={(userInfo && userInfo.Name != "" && userInfo.Name) || (UI && UI.Name != "" && UI.Name) || "avatar"}
                    roundedCircle />
                olá, &nbsp;
                <Container fluid className="verticalAlignment fullWidth">
                    <strong>{userInfo?.Name || (UI?.Name != null && UI.Name?.trim()) || (UI?.Email != null && UI.Email?.trim()) || "desconhecido@edp.com.br"}</strong>
                    {
                        currentCompany?.Name != null && currentCompany.Name != "" &&
                        <Container fluid className="horizontalAlignment fullWidth">
                            <strong>({currentCompany?.Name?.trim()})</strong>
                        </Container>
                    }
                </Container>
                <DynamicIcon Family="FontAwesome5" Name="FaCaretDown" />
            </Accordion.Button>
        )
    }

    return (
        <div className="verticalAlignment">
            <div className="horizontalAlignment">
                <NavDropdown
                    id="navbar-avatar"
                    title={UserHeader()}
                    align="end"
                >
                    <Container ref={avatarRef} >
                        <AuthenticatedTemplate>
                            <Container id="navbar-avatar-content" fluid className="verticalAlignment fullWidth">

                                <Container fluid className="horizontalAlignment fullWidth">
                                    <MasterSelectorActivate />
                                </Container>

                                <Container fluid className="horizontalAlignment fullWidth">
                                    <CompanySelection removeFeedback />
                                </Container>

                                <Dropdown.Divider />

                                <Container fluid className="horizontalAlignment fullWidth">
                                    <SignOutButton />
                                </Container>
                            </Container>
                        </AuthenticatedTemplate>

                        <UnauthenticatedTemplate>
                            <Container fluid className="horizontalAlignment fullWidth">
                                <SignInButton />
                            </Container>
                        </UnauthenticatedTemplate>
                    </Container>
                </NavDropdown>
            </div>
        </div>
    )
}

const RenderProposalSearcher = (isAdmin: boolean): JSX.Element => {

    const iconProps: IconBaseProps = { className: "icon-search" },
        navigate = useNavigate(),
        handleClick = () => {
            const serachTerm: string = helper.GetTextValueFromView("search-input");

            if (serachTerm) {
                isAdmin ?
                    navigate(`/Admin/Proposals?q=${serachTerm}`) :
                    navigate(`/Proposal/All?q=${serachTerm}`);
            }
        };

    return (
        <Form
            id="navbar-form"
            onSubmit={(event) => event.preventDefault()}
        >
            <Form.Group className="form-group">
                <Form.Control
                    className="form-control navbar-left"
                    id="search-input"
                    type="search"
                    placeholder="Pesquisar Proposta."
                    aria-label="Pequisar"

                    onKeyDown={(e) => e && (e.code == "Enter" || e.code == "NumpadEnter") && handleClick()}
                    onDragEnter={handleClick}
                />
                <Button
                    id="search-cmd"
                    title="Buscar"
                    type="button"
                    onClick={handleClick}>
                    <DynamicIcon Family="BootstrapIcons" Name="BsSearch" propsIcon={iconProps} />
                </Button>
            </Form.Group>
        </Form>
    )
}

const Header = ({ headerRef = undefined }: { headerRef?: RefObject<HTMLElement> }): JSX.Element => {
    const { userInfo, userMenus, IsMasterActive } = useContext(RdContext) as RdContextType,
        isAdmAuthorized: boolean = isAuthorized("Admin"),
        adminMenus = ((IsMasterActive || isAdmAuthorized) && userMenus.filter(x => x.Type == "manageAdmin")) || [];

    return (
        <div id="rdHeader" className="remove-print">
            <Navbar
                ref={headerRef}
                collapseOnSelect
                className="navbar-default"
                fixed="top"
                expand="xxl"
            >
                <Container fluid>
                    <Container className="navbar-header" fluid>
                        <Navbar.Brand className="navbar-brand" href="/">
                            <Image src={LogoBranco} alt="EDP Logo" fluid /> | &nbsp; Reuniões On-line
                        </Navbar.Brand>
                        <Navbar.Toggle
                            as={Card.Header}
                            className="navbar-toggle"
                            aria-expanded="true"
                            aria-controls="navbar-menu"
                        />
                    </Container>
                    <Navbar.Collapse id="navbar-menu" className="justify-content-end">
                        {RenderProposalSearcher(isAdmAuthorized)}
                        <hr role="separator" />
                        <Nav className="me-auto">
                            <RenderConfigMenus menus={adminMenus} isUserAuthorized={IsMasterActive || isAdmAuthorized} />
                            <hr role="separator" />
                            {
                                window.innerWidth <= 1280 &&
                                <Container fluid className="sideMenuInNavBar" >
                                    <SideMenu />
                                    <hr role="separator" />
                                </Container>
                            }
                            <RenderUserMenu userInfo={userInfo} />
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    )
}

export default Header;